import { render } from "./AppleSignin.vue?vue&type=template&id=3adc45ff"
import script from "./AppleSignin.vue?vue&type=script&lang=js"
export * from "./AppleSignin.vue?vue&type=script&lang=js"

import "./AppleSignin.vue?vue&type=style&index=0&id=3adc45ff&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__